module.exports = __webpack_public_path__ + "img/data.8a267269.png";